module.exports = __webpack_public_path__ + "img/chat.aa3b705b.svg";